import { SelectProps } from 'antd';
import { PermissionsEnum, RoleOutput } from 'gql/types';
import { FormItem } from 'modules/common/components';
import OfficeSelect from 'modules/locations/components/OfficeSelect';
import { useCurrentUser } from 'modules/user/hooks/useCurrentUser';
import { FC } from 'react';
import { UseControllerProps } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

type AssignedOfficeSelectProps = {
  control: Omit<UseControllerProps<any>, 'name'>;
  disabled: boolean;
  userRole: RoleOutput;
  error?: string;
} & SelectProps;

const AssignedOfficeSelect: FC<AssignedOfficeSelectProps> = ({
  control,
  disabled,
  userRole,
  ...restProps
}) => {
  const { t } = useTranslation('admin.EditUserForm');
  const user = useCurrentUser();
  const isAllowToUpdate = user.isCan(
    PermissionsEnum.UpdateProductLocationPreference
  );

  return (
    <FormItem label={t('assignedOffice')}>
      <OfficeSelect
        {...restProps}
        controlled={{
          ...control,
          name: 'assignedOffice',
        }}
        disabled={disabled || !isAllowToUpdate}
      />
    </FormItem>
  );
};

export default AssignedOfficeSelect;
